// src/admin/AdminLogin.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const AdminLogin = () => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');

        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(credentials)
            });
            const result = await response.json();

            if (result.success) {
                // Save admin status locally (Simple Auth)
                localStorage.setItem('isAdmin', 'true');
                localStorage.setItem('adminUser', result.user.username);
                navigate('/admin/dashboard');
            } else {
                setError('Invalid Username or Password');
            }
        } catch (err) {
            console.error(err);
            setError('Server connection failed');
        }
    };

    return (
        <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
            <div className="bg-white rounded-3xl p-8 md:p-12 w-full max-w-md shadow-2xl">
                <div className="text-center mb-10">
                    <h1 className="text-3xl font-black text-slate-900 uppercase tracking-tighter">Admin <span className="text-orange-500">Panel</span></h1>
                    <p className="text-slate-400 text-sm mt-2">Sign in to manage Acadfinity</p>
                </div>

                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Username</label>
                        <input 
                            type="text" 
                            name="username" 
                            value={credentials.username}
                            onChange={handleChange}
                            className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-700 outline-none focus:border-orange-500 transition-colors"
                            placeholder="Enter username"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-xs font-bold text-slate-500 uppercase tracking-widest mb-2">Password</label>
                        <input 
                            type="password" 
                            name="password" 
                            value={credentials.password}
                            onChange={handleChange}
                            className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl font-bold text-slate-700 outline-none focus:border-orange-500 transition-colors"
                            placeholder="••••••••"
                            required
                        />
                    </div>

                    {error && (
                        <div className="bg-red-50 text-red-500 text-xs font-bold p-3 rounded-lg text-center">
                            {error}
                        </div>
                    )}

                    <button 
                        type="submit" 
                        className="w-full bg-slate-900 text-white py-4 rounded-xl font-black uppercase tracking-widest hover:bg-orange-500 transition-colors shadow-lg"
                    >
                        Login
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;